import React from 'react';
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import LabelledMuiTypography from "../../../../../ui/mui/mui-display-data/LabelledMuiTypography";
import useApiGetSchedaCostoDetail from "./api-hooks/useApiGetSchedaCostoDetail";

interface Props {
    order_id?: number,
}

const SchedaCostoTanneryDyeingCard = ({order_id: order_id}: Props) => {
    const theme = useTheme();
    const fontSize = 18;


    const {data: detailedObj, isSuccess, isFetched} = useApiGetSchedaCostoDetail(order_id);


    return (
        <>
            <Box component="fieldset" sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                border: '1px solid lightgrey',
                borderRadius: '4px',
                padding: '10px',
                backgroundColor: theme.palette.backgroundAppGarageColor.main
            }}>
                <legend style={{
                    padding: '0 8px',
                    color: theme.palette.primary.main,
                    fontWeight: 500
                }}>
                    Tintura
                </legend>

                <>
                    <LabelledMuiTypography
                        label={'Kg caricati'}
                        value={detailedObj?.effective_kg?.toFixed(2)}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />


                </>

            </Box>

        </>
    );
}

export default SchedaCostoTanneryDyeingCard;